import { render, staticRenderFns } from "./CasinoEntranceButton.vue?vue&type=template&id=37318aac&scoped=true&"
import script from "./CasinoEntranceButton.vue?vue&type=script&lang=ts&"
export * from "./CasinoEntranceButton.vue?vue&type=script&lang=ts&"
import style0 from "./CasinoEntranceButton.css?vue&type=style&index=0&id=37318aac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37318aac",
  null
  
)

export default component.exports